import { CONFIG } from '../helper/config';
import { getRequestOptions, handleResponse, handleError } from './service-utilities';

export const PvpLibraryService = {
    getPvpCard,
    getDistinctColumnValues,
    runSimulation,
    updateUserQuery,
}

/**
 * Fetches the pvp card data for the given info and auth token.
 * @param {object} info The info object containing the necessary data.
 * @param {string} auth_token The authentication token to use for the request.
 * @param {string} query_id The id of the query to be used for the request.
 * @returns {Promise} A promise that resolves to the server response.
 */
function getPvpCard(info: any, auth_token:string,query_id:any) {
    let url = CONFIG.API.BASEURL + CONFIG.API.BACKEND  + CONFIG.API.REQUESTURL.GETPVPCARD+CONFIG.API.REQUESTURL.REQUEST +query_id;    
    let request_options : any = getRequestOptions(CONFIG.API.REQUESTMETHOD.POST,auth_token ,JSON.stringify(info))
    return fetch(url, request_options).then(handleResponse).catch(handleError);
}

/**
 * Fetches distinct column values for a given query.
 * @param {object} info - The info object containing the necessary data.
 * @param {string} auth_token - The authentication token to use for the request.
 * @param {string} query_id - The ID of the query for which distinct column values are to be fetched.
 * @returns {Promise} A promise that resolves to the server response.
 */
function getDistinctColumnValues(info: any, auth_token:string,query_id:any) {
    let url = CONFIG.API.BASEURL + CONFIG.API.BACKEND  + CONFIG.API.REQUESTURL.GETPVPCARD +query_id + CONFIG.API.REQUESTURL.DYNAMICFILTERS;    
    let request_options : any = getRequestOptions(CONFIG.API.REQUESTMETHOD.POST,auth_token,JSON.stringify(info))
    return fetch(url, request_options).then(handleResponse).catch(handleError);
}

/**
 * Runs a simulation based on the given info and auth token.
 * @param {object} info The info object containing the necessary data.
 * @param {string} auth_token The authentication token to use for the request.
 * @returns {Promise} A promise that resolves to the server response.
 */
function runSimulation(info: any, auth_token:string) {
    let url = CONFIG.API.BASEURL + CONFIG.API.BACKEND  + CONFIG.API.REQUESTURL.RUNSIMULATION ;
    let request_options : any = getRequestOptions(CONFIG.API.REQUESTMETHOD.POST,auth_token,JSON.stringify(info))
    return fetch(url, request_options).then(handleResponse).catch(handleError);
}

/**
 * Updates a query based on the given info and auth token.
 * @param {object} info The info object containing the necessary data.
 * @param {string} auth_token The authentication token to use for the request.
 * @param {string} req_id The id of the query to be used for the request.
 * @returns {Promise} A promise that resolves to the server response.
 */
function updateUserQuery(info: any, auth_token:string,req_id:any) {
    let url = CONFIG.API.BASEURL + CONFIG.API.BACKEND  +CONFIG.API.REQUESTURL.GETPVPCARD+ CONFIG.API.REQUESTURL.REQUEST+req_id+CONFIG.API.REQUESTURL.UPDATEQUERY;    
    let request_options : any = getRequestOptions(CONFIG.API.REQUESTMETHOD.POST,auth_token ,JSON.stringify(info))
    return fetch(url, request_options).then(handleResponse).catch(handleError);
}